import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from "./Components/Home";
import About from "./Components/About";
import Navbar from "./Routes/Navbar";
// <!-- Libraries Stylesheet -->
import './lib/animate/animate.min.css';
import './lib/owlcarousel/assets/owl.carousel.min.css';
// <!-- Customized Bootstrap Stylesheet -->
import './css/bootstrap.min.css';
// <!-- Template Stylesheet -->
import './css/style.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Services from './Components/Services';
import Contact from './Components/Contact';
import Partners from './Components/Partners';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Header/>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contactus" element={<Contact />} />
          <Route path="/partners" element={<Partners />} />
        </Routes>
      
    <Footer/>
    </BrowserRouter>
    </div>
  )
}
export default App;